<div class="notification">
  <i class="k-icon k-i-{{ color }}"></i>
  <ng-content></ng-content>
</div>
